import NavigationBar from "../components/navigationBar";
import FooterView from "../components/footerView";
import PrivacyPolicyComponents from "../components/miscellaneous-page-components/privacyPolicyComponents";
import MiscHeader from "../components/miscellaneous-page-components/miscHeader";


export default function PrivacyPolicy() {

    return (
        <div>

            <NavigationBar />
            <MiscHeader title="Privacy Policy" />
            <PrivacyPolicyComponents />
            <FooterView />
        </div>
    )
}